let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9seb7")).then(() => parcelRequire('dXB7R'));